import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "taskLogModal",
  tabindex: "-1",
  "aria-labelledby": "addModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  key: 0,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 1,
  for: "logHours"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 2,
  for: ""
}
const _hoisted_13 = { for: "" }
const _hoisted_14 = {
  key: 0,
  class: "form-group"
}
const _hoisted_15 = {
  key: 1,
  class: "form-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.selectedTask.name)
              ? (_openBlock(), _createBlock("h5", _hoisted_6, _toDisplayString(_ctx.$t('log_on')) + " " + _toDisplayString(_ctx.selectedTask.name), 1))
              : _createCommentVNode("", true),
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTaskLogModal && _ctx.hideTaskLogModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.createPhase,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + " :", 1),
              _createTextVNode(_toDisplayString(_ctx.state.data.log.todayDate), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              (_ctx.selectedTask.log_type === 0)
                ? _withDirectives((_openBlock(), _createBlock("input", {
                    key: 0,
                    type: "checkbox",
                    id: "logHours",
                    name: "logHours",
                    value: "hour",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.log.maintainedBy = $event))
                  }, null, 512)), [
                    [_vModelCheckbox, _ctx.state.data.log.maintainedBy]
                  ])
                : _createCommentVNode("", true),
              (_ctx.selectedTask.log_type === 0)
                ? (_openBlock(), _createBlock("label", _hoisted_10, _toDisplayString(_ctx.$t('maintain_by_hours')), 1))
                : _createCommentVNode("", true),
              _hoisted_11,
              (_ctx.state.data.log.maintainedBy)
                ? (_openBlock(), _createBlock("label", _hoisted_12, _toDisplayString(_ctx.$t('hours')), 1))
                : _createCommentVNode("", true),
              (_ctx.state.data.log.maintainedBy && _ctx.selectedTask.log_type === 0)
                ? _withDirectives((_openBlock(), _createBlock("input", {
                    key: 3,
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.log.hour = $event))
                  }, null, 512)), [
                    [_vModelText, _ctx.state.data.log.hour]
                  ])
                : _createCommentVNode("", true),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('remarks')), 1),
              (_ctx.selectedTask.log_type != 4)
                ? _withDirectives((_openBlock(), _createBlock("textarea", {
                    key: 4,
                    class: "form-control",
                    rows: "5",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.log.detail = $event))
                  }, null, 512)), [
                    [_vModelText, _ctx.state.data.log.detail]
                  ])
                : _createCommentVNode("", true)
            ]),
            (!_ctx.state.data.log.maintainedBy)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  (_ctx.selectedTask.log_type == 0)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn default-btn mr-2",
                        type: "submit",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.update(1)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.createPhase ? _ctx.$t('loading1'): _ctx.$t('start')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTask.log_type === 1)
                    ? (_openBlock(), _createBlock("button", {
                        key: 1,
                        class: "btn default-btn outline",
                        type: "submit",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.update(2)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.createPhase ? _ctx.$t('loading1'): _ctx.$t('pause')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTask.log_type === 2)
                    ? (_openBlock(), _createBlock("button", {
                        key: 2,
                        class: "btn default-btn outline",
                        type: "submit",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.update(3)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.createPhase ? _ctx.$t('loading1'): _ctx.$t('resume')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTask.log_type === 3 || _ctx.selectedTask.log_type === 1)
                    ? (_openBlock(), _createBlock("button", {
                        key: 3,
                        class: "btn default-btn outline",
                        type: "submit",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.update(4)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.createPhase ? _ctx.$t('loading1'): _ctx.$t('end')), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("button", {
                    class: "btn default-btn mr-2",
                    type: "submit",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.update(4))),
                    disabled: _ctx.state.ui.isPostLoading.createPhase
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createPhase ? _ctx.$t('loading1') : _ctx.$t('submit_hour')), 9, ["disabled"])
                ]))
          ])
        ])
      ])
    ])
  ]))
}